import { useFormContext } from 'react-hook-form';
import { IChangePasswordFormData } from '../../../model/IChangePasswordFormData';

export function useChangePasswordFormContext() {
	return useFormContext<IChangePasswordFormData>();
}
